if (!customElements.get('wlsn-main-blog-nav-tabs')) {
  class WLSNMainBlogNavTabs extends HTMLElement {
    constructor() {
      super();

      this.classes = {
        active: 'active',
        tabLink: 'js-main-blog-tab-link',
        slider: 'js-slider',
      };

      this.bindMethods = {
        onTabClick: this._onTabClick.bind(this),
      };

      this.navSwiperInstance = null;
    }

    /**
     * Get DOM elements
     * @returns {object} - Object containing DOM element references
     */
    get elements() {
      return {
        tabLinks: this.querySelectorAll(`.${this.classes.tabLink}`),
        slider: this.querySelector(`.${this.classes.slider}`),
      };
    }

    /**
     * Connected callback lifecycle method
     * @returns {void}
     */
    connectedCallback() {
      this.elements.tabLinks.forEach((tabLink) => {
        tabLink.addEventListener('click', this.bindMethods.onTabClick);
      });
      this._initNavSlider();
    }

    /**
     * Disconnected callback lifecycle method
     * @returns {void}
     */
    disconnectedCallback() {
      this.elements.tabLinks.forEach((tabLink) => {
        tabLink.removeEventListener('click', this.bindMethods.onTabClick);
      });
      this._destroyNavSlider();
    }

    /**
     * Initialises Swiper on the nav slider element.
     * @returns {void}
     */
    _initNavSlider() {
      if (typeof Swiper === 'undefined') return;

      const { slider } = this.elements;
      if (!slider) return;

      const spaceBetween = parseFloat(getComputedStyle(document.documentElement).fontSize) * 1.6;

      this.navSwiperInstance = new Swiper(slider, {
        slidesPerView: 'auto',
        spaceBetween,
        centerInsufficientSlides: true,
        grabCursor: true,
        threshold: 4,
      });
    }

    /**
     * Destroys the nav Swiper instance and clears the reference.
     * @returns {void}
     */
    _destroyNavSlider() {
      if (this.navSwiperInstance && !this.navSwiperInstance.destroyed) {
        this.navSwiperInstance.destroy(true, true);
        this.navSwiperInstance = null;
      }
    }

    /**
     * Handle tab click event
     * @param {Event} event - The click event
     * @returns {void}
     */
    _onTabClick(event) {
      event.preventDefault();
      const currentTabLink = event.currentTarget;
      if (currentTabLink.classList.contains(this.classes.active)) return;

      const url = new URL(currentTabLink.href);

      window.WLSNHelpers.triggerEvent(this, 'wlsn:main-blog-nav-tabs:tab-clicked', { url: url.toString() });
    }
  }

  customElements.define('wlsn-main-blog-nav-tabs', WLSNMainBlogNavTabs);
}
